/**
 * MIST CMS client. All content comes from the backend; nothing hardcoded.
 */
import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

export async function getPage(slug) {
  const { data } = await api.get(`/pages/${slug}`);
  return data;
}
export async function getNavigation() {
  const { data } = await api.get(`/navigation`);
  return data;
}
export async function getFooter() {
  const { data } = await api.get(`/footer`);
  return data;
}
export async function getSiteSettings() {
  const { data } = await api.get(`/site-settings`);
  return data;
}
export async function getServices() {
  const { data } = await api.get(`/services`);
  return data;
}
export async function getService(slug) {
  const { data } = await api.get(`/services/${slug}`);
  return data;
}
export async function getIndustries() {
  const { data } = await api.get(`/industries`);
  return data;
}
export async function getIndustry(slug) {
  const { data } = await api.get(`/industries/${slug}`);
  return data;
}
